module.exports = __webpack_public_path__ + "img/icon_location_darkred.122b2ac6.svg";